<template>
    <div>
        <main-title title="Distribuidores y librerías" />
        <div id="map1" style="height: 350px; margin-bottom: 1rem;"></div>
        <div class="row">
            <div class="col-3">
                <div class="filterCategoryTitle" style="padding-bottom: .25rem; margin-bottom: .5rem;"><b>Provincias</b></div>
                <div v-for="(provincia, index) in provincias" :key="index" style="cursor:pointer;" @click="filterByProvincia(provincia)">
                    <div v-if="provsel === provincia" style="font-weight: bold;">{{provincia}}</div>
                    <div v-else>{{provincia}}</div>
                </div>
            </div>
            <div class="col-9 pl-4 pl-md-0">
                <div v-for="(items, zone) in filterLibrary" :key='zone' class="m-2">
                    <b style="text-transform: uppercase;">{{zone}}</b>
                    <div class="d-flex flex-wrap">
                        <div v-for="library in items" :key="library.id" class="fichadistribuidor" @click="centrarmapa(library)">
                            <div class="distribuidortitulo">{{library.libreria}}</div>
                            {{library.direccion}}
                            <div v-if="library.mail"><b>Mail:</b> {{library.mail}}</div>
                            <div v-if="library.telefono"><b>Teléfono:</b> {{library.telefono}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MainTitle from "@/components/MainTitle.vue";
import axios from "axios";

export default {
  components: {
    MainTitle
  },
  data() {
    return {
        map: null,
        provincias: [],
        librerias: [],
        filterLibrary: {},
        provsel: null,
    }
  },
  mounted() {
    this.initMap();
  },
  methods: {
    // Initialize and add the map
    initMap: function() {
      // The location of Uluru
      const google = window.google;
      var uluru = { lat: -34.601005, lng: -58.395255 };
      // The map, centered at Uluru
      this.map = new google.maps.Map(document.getElementById("map1"), {
        zoom: 15,
        center: uluru,
        streetViewControl: false,
        mapTypeControl: false
      });
      // The marker, positioned at Uluru
      /*
      var marker = new google.maps.Marker({ position: uluru, map: map });
      return marker; 
      */
      this.loadLibraries();
    },
    async loadLibraries() {
      console.log(this.$store.state.user.siteData);

      this.provincias = [];
      this.filterLibrary = {};
      this.librerias = await axios
        .post(
          this.$store.state.user.siteData.location + "distribuidores/distribuidores/getAll",
          null,
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            
            element.mapinfo = this.addMarker(element);
            result.push(element);
            
            console.log(element.mapinfo);

            if (element.provincia !== '' && !this.provincias.includes(element.provincia)){
                this.provincias.push(element.provincia);
            }
          });

          this.provincias.sort();
          
          return result;
        });
        
        this.filterByProvincia('CAPITAL FEDERAL');
    },
    addMarker: function(data){
      const google = window.google;
      const map = this.map;
      var uluru = { lat: parseFloat(data.lat), lng: parseFloat(data.lng) };
      console.log(data);


      const marker = new google.maps.Marker({
                            position: uluru,
                            map,
                            title: data.libreria,
                        });

      let content = '<div>' +
          '<h3 class="firstHeading">' +
          data.libreria + 
          '</h3>' +
          '<div>'+data.direccion+'</div>';
      if (data.mail){
          content += '<div>' + data.mail + '</div>';
      }
      if (data.telefono){
          content += '<div>' + data.telefono + '</div>';
      }
      
      const inforwindows = new google.maps.InfoWindow({
        content: content
      })

      marker.addListener('click', () => {
        this.cerrartodo();
        inforwindows.open(map, marker)
      })

      return {marker, inforwindows}
    },
    filterByProvincia(provincia){
       this.filterLibrary = {};
       this.librerias.forEach((element) => {
           if (element.provincia === provincia){
               if (this.filterLibrary[element.zona] === undefined){
                   this.filterLibrary[element.zona] = [];
               }
               this.filterLibrary[element.zona].push(element);
               console.log(this.filterLibrary[element.zona]);
           }
       });
       this.provsel = provincia;
    },
    centrarmapa(element){
        this.cerrartodo();
        /*
        this.map.setCenter(element.mapinfo.marker.getPosition());
        */
       element.mapinfo.inforwindows.open(this.map, element.mapinfo.marker)
    },
    cerrartodo(){
      this.librerias.forEach((element) => {
          element.mapinfo.inforwindows.close();
      });  
    }
  }
};
</script>